<template>
  <my-dialog class="call-dialog" width="600px" :show="show" title="欢迎使用免费电话呼叫" @close="onClose">
    <div class="call-inner">
      <div class="form-item clear">
        <label class="label">您的电话：</label>
        <div class="input-box">
          <input type="text" v-model.number="myPhone" class="input" />
          <button class="btn-call" @click="callUp">免费呼叫</button>
        </div>
      </div>
      <ul class="tip-list">
        <li>1、固定电话、小灵通在号码前加区号，如：010**</li>
        <li>2、手机号码直接收入，如13810******</li>
        <li>
          3、此次呼叫为免费呼叫，您无需承担任何费用，您的电话也不会被泄露，请放心拨打！
          特别提示：请勿非法呼叫、恶意拨打！
        </li>
      </ul>
    </div>
  </my-dialog>
</template>
<script>
import myDialog from './gkDialog.vue'
import { FreeCallPhone } from "@/scripts/api.js";
import valid from "@/scripts/validate.js";
export default {
  components:{
    myDialog
  },
  props:{
    show:{
      type:Boolean,
      default:false
    },
    phone:{
      type:String,
      default:'',
    },
    isLongTime:{
      type:Boolean,
      default:false
    },
    jobId:{
      type:[String,Number],
    },
  },
  data(){
    return{
      myPhone:'',
    }
  },
  methods: {
    // 打电话
    callUp() {
      if (!this.phone) {
        this.$toast("被叫号码不能为空");
        return;
      }
      if (!valid.link(this.myPhone)) {
        this.$toast("请输入正确的电话号码或者手机号！");
        return;
      }
      FreeCallPhone({
        jobId: this.jobId || 0,
        isLongTime: this.isLongTime,
        aNumber: this.myPhone,
        bNumber: this.phone,
        platform: "pcweb",
      }).then((r) => {
        if (r.Result == 1) {
          this.$emit('close');
          this.$alert("您呼叫的电话号码为：" + r.Data.PrivateNumber);
        } else {
          this.$toast(r.Message);
        }
      });
    },
    onClose(){
      this.$emit('close');
    }
  },
}
</script>
<style lang="scss">
.call-dialog{
  .call-inner {
    padding: 20px 20px 0;
  }
  .form-item {
    position: relative;
    margin-bottom: 20px;
    width: 100%;
    padding-left: 100px;
    .label {
      width: 100px;
      line-height: 40px;
      font-size: 14px;
      color: #333;
      position: absolute;
      left: 0;
      top: 0;
    }
    .input-box {
      width: 100%;
      position: relative;
      height: 40px;
      padding-right: 100px;
    }
    .input {
      width: 100%;
      height: 40px;
      padding: 8px 10px;
      font-size: 14px;
      color: #333;
      line-height: 22px;
      border: 1px solid #e5e5e5;
    }
    .btn-call {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 2;
      width: 100px;
      height: 40px;
      font-size: 14px;
      color: #fff;
      text-align: center;
      line-height: 40px;
      background-color: #f75959;
      cursor: pointer;
    }
  }
  .tip-list {
    font-size: 14px;
    color: #999;
    line-height: 24px;
    li {
      margin-bottom: 6px;
    }
  }
}
</style>